import axios from 'axios';

const baseUrl =
  process.env.REACT_APP_QCX_API_BASE_URL! +
  '/followup/report/aguardando-faturamento';

export const generateAguardandoFaturamentoReport = async (
  token: string,
  unidadeId: string,
  tenantIds: string[],
  clientIds: string[],
  processIds: string[],
  viaId: string | null,
  startISO: string,
  endISO: string,
  produto: string,
): Promise<string | null> => {
  const p = new URLSearchParams();
  p.set('tenantId', tenantIds.join(','));
  if (clientIds.length) p.set('clientesId', clientIds.join(','));
  if (processIds.length) p.set('processosId', processIds.join(','));
  if (viaId) p.set('viaId', viaId);
  p.set('insertionDateRange', `${startISO};${endISO}`);
  p.set('produto', produto);

  try {
    const r = await axios.get(`${baseUrl}?${p.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
      validateStatus: () => true,
    });

    if (r.status === 200) {
      const file = new File(
        [r.data],
        'aguardando-faturamento.xlsx',
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url; a.download = file.name; a.click();
      return null;
    }
    return await r.data.text();
  } catch {
    return 'Erro ao gerar o relatório.';
  }
};
